import React from 'react';
import PropTypes from 'prop-types';
import CCLRichText from '@deliveroo/consumer-component-library/components/RichText';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import CollapsibleSection from '../../../../components/CollapsibleSection';
import styles from './styles.scss';

class Collapsible extends React.Component {
  validateProps({ isOpen }) {
    return typeof isOpen === 'boolean';
  }

  componentDidMount() {
    const { isOpen } = this.props;

    if (!this.validateProps({ isOpen })) {
      throw new Error(`Incorrect prop-types for Storyblok Collapsible component`);
    }
  }

  render() {
    const { heading, isOpen, html } = this.props;
    return (
      <Spacer spacing="medium 0">
        <div className={styles.collapsibleHeading}>
          <CollapsibleSection heading={heading} isOpen={isOpen}>
            <CCLRichText>
              {/* this output is already sanitised by Storybook's markdown-html plugin */}
              {/* eslint-disable-next-line react/no-danger */}
              <div dangerouslySetInnerHTML={{ __html: html }} />
            </CCLRichText>
          </CollapsibleSection>
        </div>
      </Spacer>
    );
  }
}

Collapsible.propTypes = {
  heading: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  html: PropTypes.string.isRequired,
};

export default Collapsible;
